// extracted by mini-css-extract-plugin
module.exports = {"linkCss":"TabLink_linkCss__2fME1","link":"TabLink_link__2J9af","tab":"TabLink_tab__PR22E"};